import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export function Reveal({ children, delay = 0, y = 30, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line heading reveal
export function MaskedLines({ lines, className = "", delay = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pt-[0.12em] -mt-[0.12em]">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function MaskedLinesInView({ lines, className = "", delay = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <motion.span key={i} className="block overflow-hidden pt-[0.12em] -mt-[0.12em]" initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}>
          <motion.span
            className="block"
            variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
            transition={{ duration: 1, ease: EASE, delay: delay + i * 0.1 }}
          >
            {line}
          </motion.span>
        </motion.span>
      ))}
    </span>
  );
}
